import React from 'react'

export const PhotoStatusPendingSvg = ({ size = '24', color = '#fff' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <path d="M11.698 5.636l-.001 7.88 5.455-.002h-5.454z" />
    </g>
  </svg>
)
